import request from '@/utils/request' //引入封装好的 axios 请求

// 更新个人信息
export function updateUser (data = {}) {
    return request({
        url: '/api/v1/user/mod',
        method: 'post',
        data: data
    })
}

// 对接记录
export function getApplyList (data = {}) {
    return request({
        url: '/api/loan/apply/list',
        method: 'post',
        data: data
    })
}

// 申请记录
export function applicationList (data = {}) {
    return request({
        url: '/api/credit/application/list',
        method: 'post',
        data: data
    })
}

// 撤销申请
export function updateApply (data = {}) {
    return request({
        url: '/api/loan/apply/examine',
        method: 'post',
        data: data
    })
}

// 获取授权对象
export function getObjectList (data = {}) {
    return request({
        url: '/api/loan/apply/bankList',
        method: 'post',
        data: data
    })
}

// 获取开户行列表
export function getBankList (data = {}) {
    return request({
        url: '/api/v1/user/bankList',
        method: 'post',
        data: data
    })
}

// 新增授权认证
export function addAuth (data = {}) {
    return request({
        url: '/api/v1/auth/add',
        method: 'post',
        data: data
    })
}

// 获取授权认证详情
export function getAuth (data = {}) {
    return request({
        url: '/api/credit/webAuth/detail',
        method: 'post',
        params: data
    })
}

// 修改和保存授权认证
export function updateAuth (data = {}) {
    return request({
        url: '/api/credit/webAuth/operate',
        method: 'post',
        data: data
    })
}

// 历史记录
export function queryAuth (data = {}) {
    return request({
        url: '/api/v1/auth/queryAuth',
        method: 'post',
        data: data
    })
}


// 银行列表
export function bankList () {
    return request({
        url: '/api/loan/apply/bankList',
        method: 'post',
        data: {}
    })
}

// 草稿箱列表
export function webAuthList () {
    return request({
        url: '/api/credit/webAuth/list',
        method: 'post',
        data: {}
    })
}

// 删除草稿
export function Delete (id) {
    return request({
        url: `/api/credit/webAuth/delete?id=${id}`,
        method: 'post',
        data: {}
    })
}



// 下载pdf
export function authFileTemp () {
    return request({
        url: "/api/v1/file/authFileTemp",
        method: 'get',
        data: {}
    })
}

export function queryUserInfoByToken () {
    return request({
        url: "/api/v1/user/getUserInfoByToken",
        method: 'get',
        data: {}
    })
}


// 其他产品列表
export function list (data = {}) {
    return request({
        url: "/api/credit/application/list",
        method: 'post',
        data: data
    })
}




// 关注申请用户
export function operate (data = {}) {
    return request({
        url: "/api/credit/application/operate",
        method: 'post',
        data: data
    })
}



// 关注申请用户
export function selectProType (data = {}) {
    return request({
        url: `/api/loan/apply/bankList`,
        method: 'post',
        data: data
    })
}